<template>
  <div>
    <v-checkbox
      v-model="dataPost[fieldName?fieldName.name:dataField.name]"
      :label="dataField.title ? dataField.title : ''"
      required
      :error="alerts[dataField.name] != null"
      :error-messages="alerts[dataField.name]"
    ></v-checkbox>
  </div>
</template>

<script>
export default {
  name: "CheckBox",
  props: ["dataField", "fieldName"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  data: () => ({}),
};
</script>
